// 回复方式枚举
export enum ReplyMode {
  KNOWLEDGE = 1, // 检索知识库回复
  FIXED = 2, // 固定回复
}

// 回复内容类型
export enum ReplyType {
  TEXT = "1", // 纯文本
  RICH_TEXT = "2", // 富文本
}

// 结束回复节点数据
export interface EndReplyNodeData {
  mode: ReplyMode;
  content?: string; // 固定回复内容，mode为FIXED时必填
  type: ReplyType;
} 